import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'ellf-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorPageComponent {
  @Input()
  type!: string;

  @Input()
  title!: string;

  @Input()
  desc!: string;

  @Input()
  showBack = true;

  @Output()
  back = new EventEmitter<void>();
}
